import Swiper from 'swiper';

export default class FirstviewSlider {
  constructor() {
    this.setup();
  }
  setup() {
    // const progressBar = document.querySelector('.l-firstviewSlider__progress');
    const currentNum = document.querySelector('.js-firstviewSlider-current');
    const totalNum = document.querySelector('.js-firstviewSlider-total');

    new Swiper('.l-firstviewSlider__slider', {
      slidesPerView: 1.5,
      centeredSlides: true,
      spaceBetween: 2,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 1000,
      followFinger: false,
      watchOverflow: true,
      autoplay: {
        delay: 8000
      },
      pagination: {
        el: '.l-firstviewSlider__pagination',
        clickable: true,
        type: 'bullets'
      },
      navigation: {
        prevEl: '.l-firstviewSlider__prev',
        nextEl: '.l-firstviewSlider__next'
      },
      breakpoints: {
        766.98: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      },
      on: {
        init: function() {
          const total = this.slides.length - 2 - 2; // loopAdditionalSlides分さらに減らす
          const zpTotal = ('00' + total).slice(-2);
          totalNum.innerText = zpTotal;
        },
        slideChange: function() {
          const num = this.realIndex + 1;
          const zpNum = ('00' + num).slice(-2);
          currentNum.innerText = zpNum;
        },
        transitionStart: function() {
          // progressBar.classList.remove('progress-start');
        },
        transitionEnd: function() {
          // progressBar.classList.add('progress-start');
        }
      }
    });
  }
}
